import { Pipe, type PipeTransform } from '@angular/core';
import type { Maybe } from '@quipex/core/primitives';
import { toKebabCase } from '@quipex/shared/utils';

@Pipe({
    name: 'qpxKebabCase',
})
export class KebabCasePipe implements PipeTransform {
    /**
     * Transforms a given string to kebab case, converting spaces to hyphens and camelCase to kebab-case.
     *
     * Example usage in a template:
     * ```
     * {{ 'Hello World' | qpxKebabCase }}
     * {{ 'myCamelCase' | qpxKebabCase }}
     * ```
     * This will render as:
     * ```
     * hello-world
     * my-camel-case
     * ```
     *
     * @param value - The input string to transform.
     * @returns The transformed string in kebab-case.
     */
    transform(value: Maybe<string>): string {
        return toKebabCase(value);
    }
}
